import { useMemo, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../components/Notifications/Sidebar";
import Wrapper from "../../components/Notifications/Wrapper";
import { useCompanyUsers } from "../../hooks/companyUsers.hooks";
import { useNotificationsFields } from "../../hooks/notificationField.hooks";
import { useStores } from "../../hooks/useStores";
import { useActiveCompany } from "../../hooks/useActiveCompany";
import { Screens } from "../../types";

export const NotificationsLayout: React.FC = () => {
  const location = useLocation();
  const { session, ui } = useStores();
  const { refetch: refetchCompanyUsers, data: companyUsers = [] } =
    useCompanyUsers();
  const activeCompany = useActiveCompany();
  const navigate = useNavigate();

  const { data: notificationsFields = [] } = useNotificationsFields();

  useEffect(() => {
    ui.setActiveScreen(Screens.NOTIFICATIONS);
  }, []);

  useEffect(() => {
    // refetch() bypassa la guardia `enabled`: attendere l'azienda valida per
    // non far partire una GET con companyId=-1.
    if (session.user?.Internal && (activeCompany || -1) > 0) {
      refetchCompanyUsers();
    }
  }, [session.user, activeCompany]);

  const activeField = useMemo(() => {
    return location.hash && location.hash.length > 0
      ? location.hash.replace("#", "")
      : "inbox";
  }, [location.hash]);

  const handleChangeUser = (event: any) => {
    navigate(`.?user=${event.target.value}`);
  };

  return (
    <Wrapper>
      <Sidebar
        notificationsFields={notificationsFields}
        activeField={activeField}
        isInternalUser={session.user?.Internal}
        companyUsers={companyUsers || []}
        onUserChange={handleChangeUser}
      />
      <Outlet />
    </Wrapper>
  );
};
